// extracted by mini-css-extract-plugin
export default {"root":"NotFoundPage_root__AoKKa","panel":"NotFoundPage_panel__6j48m"};